import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'primereact/button';
import { useApi } from '../providers/api-provider';
import { ListCourseDto } from '../general/dtos';
import { formatCoursePrice } from '../general/currency';
import '../assets/pricing.css';
import '../assets/theme-content.css';

export default function PricingPage() {
    const api = useApi();
    const [products, setProducts] = useState<ListCourseDto[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [revision, setRevision] = useState(0);

    useEffect(() => {
        if (!api) return;
        let active = true;
        setLoading(true);
        setError(false);
        // Always use the public catalogue, including products a signed-in user owns.
        api.getProducts(false).then(result => {
            if (!Array.isArray(result?.data)) throw new Error('Invalid product catalogue response.');
            if (active) setProducts(result.data);
        }).catch(() => {
            if (active) setError(true);
        }).finally(() => {
            if (active) setLoading(false);
        });
        return () => { active = false; };
    }, [api, revision]);

    return <div className="pricing-page theme-content">
        <h1 className="page-title public-page-title">Pricing</h1>
        <div className="pricing-inner">
            <header className="pricing-header">
                <p>Explore our teacher training products and find the right fit for your professional development.</p>
                <p className="pricing-note">One-time prices in British pounds (GBP), including applicable taxes.</p>
            </header>

            {loading ? <p role="status">Loading product prices…</p>
                : error ? <div role="alert" className="pricing-feedback">
                    <p>Could not load product prices. Please try again.</p>
                    <Button label="Retry" icon="pi pi-refresh" outlined onClick={() => setRevision(value => value + 1)} />
                </div>
                : products.length === 0 ? <p role="status">There are no products available at the moment. Please check back soon.</p>
                : <ul className="pricing-products" aria-label="Product prices">
                    {products.map(product => <li key={product.course_key} className="pricing-product">
                        <div className="pricing-product-details">
                            <h2>{product.name}</h2>
                        </div>
                        <p className="pricing-product-price">{formatCoursePrice(product.price)}</p>
                    </li>)}
                </ul>}

            <footer className="pricing-footer">
                <Link to="/products" className="pricing-browse">Explore products <i className="pi pi-arrow-right" aria-hidden="true" /></Link>
                <nav aria-label="Pricing policies">
                    <Link to="/terms-of-use">Terms &amp; conditions</Link>
                    <Link to="/refund-policy">Refund &amp; cancellation policy</Link>
                    <Link to="/privacy-policy">Privacy policy</Link>
                </nav>
            </footer>
        </div>
    </div>;
}
